import './home.css';

import img2 from '../imgs/image2.jpg';


// import { useState } from 'react';

import { palleteStr } from '../ui/theme';
import { Button } from '../ui/buttons';
import Navbar from './navbar';
import Footer from './footer';
import Features from './features';

export const ELEVATOR = <>
    Struggling to remember what you learn online? <br></br>
    <span className="hero-txt fs-4"> LearnXcess </span> uses proven methods to make learning fun and effective.
    Get personalized help and connect with a supporting community!
</>;

export default function HomePage({ scroll, setSignIn }) {
    return (
        <div className="home">
            <div className="mega-max">
                <div className='abs bg-img max veil' style={{ backgroundImage: `url(${img2})` }}>
                </div>
                <Navbar scroll={scroll} />
                <MainSlide setSignIn={setSignIn} />
            </div>
            <div className='pad'>
                <Features />
            </div>

            <Footer />

        </div>
    )
}


function MainSlide({setSignIn}) {
    const location = window.location;


    return (
        <ViewItem className="fw abs-mid-y" style={{ color: "white" }}>
            <div className="flex margin mid-align">
                <div className="fw flex-col center-text">
                    <p id="elevator" className="pad"> {ELEVATOR} </p>
                    <div>
                        <Button className="br-1" onClick={() => {
                            setSignIn("register");
                        }}>
                            <div className="flex mid-align gap-2">
                                <span> Get Started </span>
                                <i className="fa-solid fa-angle-right"></i>
                            </div>
                        </Button>
                    </div>
                </div>
            </div>
        </ViewItem>
    )

}


export function ViewItem(props) {
    const { children } = props;

    return (
        <div {...props} style={{ padding: "50px 0", margin: "20px 0" }}>
            <div className='content max sec-1'>
                {children}
            </div>
        </div>
    )
}